import React, { useState } from 'react'
import { Avatar, Button, Card, Popconfirm, Table, Form } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import NotificationForm from './NotificationForm'
import {
  createNotification,
  deleteNotification,
  fetchNotificationList,
  updateNotification
} from '../../modules/notification'
import _ from 'lodash'
import moment from 'moment'
import g2gImage from '../../assets/images/g2g.png'
import heroImage from '../../assets/images/icon_hero_green2get.png'

const initialOptions = {
  size: 20,
  page: 0
}

const Notification = (props) => {
  const { form } = props
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [options, setOptions] = useState(initialOptions)

  const { notificationList, isLoading } = useSelector(
    (state) => ({
      notificationList: state.notification.notificationList,
      isLoading: state.notification.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchNotificationList(options))
    }

    fetch()
  }, [])

  const columns = [
    {
      title: 'Target',
      dataIndex: 'userReceiverTypeId',
      key: 'logo',
      align: 'center',
      width: 80,
      render: (userReceiverTypeId, record) =>
        userReceiverTypeId === 2 ? (
          <Avatar src={g2gImage} size={36} shape="square" />
        ) : (
          <Avatar src={heroImage} size={36} shape="square" />
        )
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (text, _) => <span>{text}</span>
    },
    {
      title: 'Text',
      key: 'message',
      dataIndex: 'message',
      render: (text, _) => <span>{text}</span>
    },
    {
      title: 'Scheduling',
      key: 'schedulingDate',
      dataIndex: 'schedulingDate',
      render: (text, _) => (
        <span>{moment(text).format('D/MMMM/YYYY HH:mm')}</span>
      )
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) =>
        moment(record.schedulingDate).isAfter(moment()) ? (
          <span>
            <Button
              type="primary"
              size="small"
              shape="circle"
              icon="edit"
              onClick={(e) => {
                onClick(e, record)
              }}
            />
          </span>
        ) : (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        )
    }
  ]

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const onCloseModal = async () => {
    await dispatch(fetchNotificationList(options))
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateNotification({ ...data, id: formData.id }))
    } else {
      await dispatch(createNotification(data))
    }

    await dispatch(fetchNotificationList(options))
    await setVisible(false)
    await setFormData({})
  }

  const onDelete = async (id) => {
    await dispatch(deleteNotification(id))
    await dispatch(fetchNotificationList(options))
  }

  async function onChange(page) {
    options.page = page - 1
    setOptions(options)
    await dispatch(fetchNotificationList(options))
  }

  async function onShowSizeChange(current, pageSize) {
    options.size = pageSize
    setOptions(options)
    await dispatch(fetchNotificationList(options))
  }

  return (
    <Card
      title="Notification"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            New Notification
          </Button>
        </div>
      }>
      <br />
      <Table
        bordered
        loading={isLoading}
        dataSource={notificationList.content}
        columns={columns}
        rowKey={(record) => {
          return record.id
        }}
        pagination={{
          current: notificationList.pageable.pageNumber + 1,
          pageSize: notificationList.size,
          pageSizeOptions: ['10', '20', '50', '100'],
          showSizeChanger: true,
          onShowSizeChange: onShowSizeChange,
          onChange: onChange,
          total: notificationList.totalElements
        }}
      />
      <NotificationForm
        visible={visible}
        formData={formData}
        form={form}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </Card>
  )
}

const WrappedNotification = Form.create({
  name: 'Notification'
})(Notification)

export default WrappedNotification
